import { Link } from 'react-router-dom';
import { footerNavigation, socialLinks } from '../data/site';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white/70 py-12 dark:border-white/10 dark:bg-white/[0.03]">
      <div className="container-page grid gap-10 lg:grid-cols-[1.2fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-md text-sm leading-6 text-slate-600 dark:text-slate-300">
            DropBridge helps Shopify merchants move from supplier discovery to cleaner, margin-aware
            product publishing.
          </p>
        </div>
        <div className="grid gap-8 sm:grid-cols-2">
          <div>
            <h2 className="text-sm font-semibold text-slate-950 dark:text-white">Navigation</h2>
            <div className="mt-4 grid gap-3">
              {footerNavigation.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-sm text-slate-600 transition hover:text-slate-950 dark:text-slate-300 dark:hover:text-white"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-sm font-semibold text-slate-950 dark:text-white">Social</h2>
            <div className="mt-4 grid gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm text-slate-600 transition hover:text-slate-950 dark:text-slate-300 dark:hover:text-white"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container-page mt-10 text-sm text-slate-500">
        © {new Date().getFullYear()} DropBridge. All rights reserved.
      </div>
    </footer>
  );
}
